import { MOBILE_NAV_ROUTES } from "../mobileRoutes";

export type MobileBottomNavIcon =
    | "home"
    | "categories"
    | "more"
    | "cart"
    | "profile";

export type MobileBottomNavItem = {
    id: string;
    label: string;
    path: string;
    icon: MobileBottomNavIcon;
};

export const MOBILE_BOTTOM_NAV_ITEMS: MobileBottomNavItem[] = [
    {
        id: "home",
        label: "Home",
        path: MOBILE_NAV_ROUTES.home,
        icon: "home",
    },
    {
        id: "categories",
        label: "Categories",
        path: MOBILE_NAV_ROUTES.categories,
        icon: "categories",
    },
    {
        id: "more",
        label: "More",
        path: MOBILE_NAV_ROUTES.more,
        icon: "more",
    },
    {
        id: "cart",
        label: "Cart",
        path: MOBILE_NAV_ROUTES.cart,
        icon: "cart",
    },
    {
        id: "profile",
        label: "Profile",
        path: MOBILE_NAV_ROUTES.profile,
        icon: "profile",
    },
];
